import React, { useEffect } from "react";
import { InputNumber } from "antd";
import { isEmpty } from "lodash";
import { getPriceMultipleTvaChecked, computeSumTvasWithout0Percentage, computeAmountFromTva } from "./../Tva.utils";
export const roundToTwoDigits = value => Math.round(value * 100) / 100;

export const TVA_RESET = [
  { percentage: 0, amount_tva: 0, label: "Pas de TVA sur le ticket", checked: false, withoutTva: 0 },
  { percentage: 5.5, amount_tva: 0, checked: false, withoutTva: 0 },
  { percentage: 10, amount_tva: 0, checked: false, withoutTva: 0 },
  { percentage: 20, amount_tva: 0, checked: false, withoutTva: 0 }
];

export const TVA_INIT = [
  { percentage: 0, amount_tva: 0, label: "Pas de TVA sur le ticket", checked: false, withoutTva: 0 },
  { percentage: 5.5, amount_tva: 0, checked: false, withoutTva: 0 },
  { percentage: 10, amount_tva: 0, checked: false, withoutTva: 0 },
  { percentage: 20, amount_tva: 0, checked: true, withoutTva: 0 }
];

const TvaForm = ({ setCalculatedPrice, expenseToModify = null, form, tvas }) => {
  const numberOfTvaChecked = tvas.filter(item => item.checked).length;

  useEffect(() => {
    if (expenseToModify && !isEmpty(expenseToModify.tva)) {
      const tvaCopy = tvas.map(item => {
        const findTva = expenseToModify.tva.find(tvaItem => {
          return Number(tvaItem.percentage) === Number(item.percentage);
        });

        if (findTva)
          return {
            ...findTva,
            withoutTva: findTva.amount - findTva.amount_tva
          };
        else return item;
      });
      form.setFieldsValue({ tva: tvaCopy });
    } else if (expenseToModify && isEmpty(expenseToModify.tva)) {
      const tvaCopy = tvas;

      tvaCopy[0].checked = true;
      form.setFieldsValue({ tva: tvaCopy });
    } else {
      form.setFieldsValue({ tva: TVA_INIT });
    }
  }, [expenseToModify]);

  const onCheck = _tva => {
    const index = tvas.findIndex(tva => tva.percentage === _tva.percentage);
    if (_tva.percentage === 0 && !_tva.checked) {
      const newTvas = tvas.map(newTva =>
        newTva.percentage === 0
          ? {
              ...newTva,
              checked: true
            }
          : {
              ...newTva,
              checked: false,
              amount_tva: 0,
              amount: 0
            }
      );
      setCalculatedPrice(0);
      form.setFieldsValue({ tva: newTvas });
      return;
    }
    if (_tva.percentage !== 0 && !_tva.checked) {
      const newTvas = tvas.map(newTva => {
        if (newTva.percentage === 0) {
          return {
            ...newTva,
            checked: false
          };
        }
        if (newTva.percentage === _tva.percentage) {
          return {
            ...newTva,
            checked: true,
            amount_tva: 0,
            amount: 0
          };
        }
        return newTva;
      });
      setCalculatedPrice(computeSumTvasWithout0Percentage(newTvas));
      form.setFieldsValue({ tva: newTvas });
      return;
    }

    if (index > -1) {
      // const newTvas = _tva.percentage === 0 ? [...TVA_RESET] : [...tvas];
      const newTvas = [...tvas];
      const newTva = {
        ...newTvas[index],
        checked: !newTvas[index].checked,
        withoutTva: 0,
        amount_tva: 0
      };
      newTvas[index] = newTva;

      //reset amount to 0 for the only tva previously checked
      if (newTvas[index].checked && numberOfTvaChecked === 1) {
        const indexTvaAlreadyChecked = newTvas.findIndex(item => item.checked && item.percentage !== _tva.percentage);
        const indexNoTva = newTvas.findIndex(item => item.checked && item.percentage === 0);

        if (indexTvaAlreadyChecked > -1)
          newTvas[indexTvaAlreadyChecked] = {
            ...newTvas[indexTvaAlreadyChecked],
            amount_tva: 0,
            withoutTva: 0
          };
        //if tva 0% has ben previously checked, unchecked
        // if (_tva.percentage !== 0 && indexNoTva !== -1 && newTvas[indexNoTva].checked)
        //   newTvas[indexNoTva].checked = false;
      }

      //if all tva are unchecked, check by default 0%
      if (!newTvas[index].checked && numberOfTvaChecked === 1) newTvas[0].checked = true;

      //reset amount to calculatedPrice TTC when switching to > 2 tva checked to only one
      if (!newTvas[index].checked && numberOfTvaChecked === 2) {
        const indexTvaChecked = newTvas.findIndex(item => item.checked);

        if (indexTvaChecked > -1)
          newTvas[indexTvaChecked] = {
            ...newTvas[indexTvaChecked],
            amount_tva: 0
          };
      }

      //when unchecking, modify calculatedPrice to remove the amount previously checked
      if (!newTvas[index].checked) {
        const tvaArrayChecked = newTvas.filter(item => item.checked);

        if (tvaArrayChecked.length > 1) setCalculatedPrice(getPriceMultipleTvaChecked(tvaArrayChecked));
      }

      form.setFieldsValue({ tva: newTvas });
    }
  };

  const onTextChange = (value, name) => {
    const index = tvas.findIndex(tva => tva.percentage === name);
    if (index > -1) {
      const withoutTva = value ? Number.parseFloat((value / tvas[index].percentage) * 100).toFixed(2) : 0;

      const newTvas = [...tvas];
      const newTva = {
        ...newTvas[index],
        amount_tva: value ? value : 0,
        withoutTva,
        amount: computeAmountFromTva(value)
      };
      newTvas[index] = newTva;

      const tvaArrayChecked = newTvas.filter(item => item.checked);

      // if (tvaArrayChecked.length > 1)
      setCalculatedPrice(getPriceMultipleTvaChecked(tvaArrayChecked));
      form.setFieldsValue({ tva: newTvas });
    }
  };

  return (
    <div className="grid grid-cols-2 gap-6">
      {tvas.map((tva, index) => {
        return (
          <div className="flex justify-between">
            <div className="flex items-center">
              <div
                style={{
                  width: 20,
                  height: 20,
                  background: tva.checked ? "mediumaquamarine" : "lightgrey",
                  marginRight: "6px",
                  borderRadius: "5px"
                }}
                onClick={() => onCheck(tva)}
              />
              <span>{tva.label || `TVA ${tva.percentage}%`}</span>
            </div>
            {tva.checked && index !== 0 && (
              // numberOfTvaChecked > 1 &&
              <div className="flex items-center">
                <div className="mr-2">(hors taxe {Number.parseFloat(tva.withoutTva).toFixed(2)} €)</div>
                <InputNumber
                  min={0}
                  onChange={e => onTextChange(e, tva.percentage)}
                  name={tva.percentage}
                  value={roundToTwoDigits(Number.parseFloat(tva.amount_tva))}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TvaForm;



// WEBPACK FOOTER //
// src/modules/presence/components/Form/Tva.form.js